export default "__VITE_ASSET__948dd020__"